var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import IconBilibili from "./Icon";
var BILIBILI_CHANNEL_ID = 2;
var AUTHORIZE_TARGET_URL = "https://passport.bilibili.com/register/oauth2.html#/";
function getAuthorizeUrl(option, state) {
    var e_1, _a;
    var clientId = option.clientId, authorizeUrl = option.authorizeUrl, redirectUrl = option.redirectUrl;
    var redirect = encodeURIComponent((redirectUrl &&
        (typeof redirectUrl === "function"
            ? redirectUrl()
            : redirectUrl)) ||
        location.href);
    var queryParams = [""];
    try {
        for (var _b = __values(new URLSearchParams()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (key !== "code") {
                queryParams.push("".concat(key, "=").concat(value));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var allState = __assign({}, state);
    var url = "".concat(authorizeUrl || AUTHORIZE_TARGET_URL, "?client_id=").concat(clientId, "&return_url=").concat(encodeURIComponent(redirect), "&response_type=code&state=").concat(encodeURIComponent(JSON.stringify(allState)));
    return url;
}
function pickAuthorizeCode() {
    var search = location.search;
    if (search.length === 0) {
        return null;
    }
    var searchParams = new URLSearchParams(search.substring(1));
    var queries = {};
    searchParams.forEach(function (val, key) {
        queries[key] = decodeURIComponent(val);
    });
    if (queries["state"] && queries["code"]) {
        try {
            var _a = JSON.parse(queries["state"]), type = _a._type, from = _a._from, state = __rest(_a, ["_type", "_from"]);
            if (type === "auth" && from === "bilibili" && queries["code"]) {
                var url = new URL(location.href);
                url.searchParams.delete("state");
                url.searchParams.delete("code");
                history.replaceState({}, "", url.toString());
                return { code: queries["code"], state: state };
            }
        }
        catch (err) { }
    }
    return null;
}
export function handler(ctx) {
    var option = ctx.option, state = ctx.state;
    location.href = getAuthorizeUrl(option, state);
}
export function recognizer(ctx) {
    return __awaiter(this, void 0, void 0, function () {
        var res, sdkReady, sdk, rep;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    res = pickAuthorizeCode();
                    if (!res)
                        return [2 /*return*/, res];
                    sdkReady = ctx.sdkReady;
                    if (!(sdkReady.SDK_TYPE === "HG")) return [3 /*break*/, 3];
                    return [4 /*yield*/, sdkReady()];
                case 1:
                    sdk = _a.sent();
                    return [4 /*yield*/, sdk.U8.API.authByChannelCode(ctx.gameCode, BILIBILI_CHANNEL_ID, res.code)];
                case 2:
                    rep = _a.sent();
                    return [2 /*return*/, {
                            token: rep,
                            state: res.state,
                        }];
                case 3:
                    if (sdkReady.SDK_TYPE === "GL") {
                        // 海外无
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/, null];
            }
        });
    });
}
export default {
    channel: "bilibili",
    displayName: "哔哩哔哩",
    renderIcon: function (props) { return _jsx(IconBilibili, __assign({}, props)); },
    handler: handler,
    recognizer: recognizer,
};
